// docs: https://github.com/altostra/type-validations#readme
import { arrayOf, objectOf, maybe } from "@altostra/type-validations";
import { boolean, number, string } from "@altostra/type-validations/lib/primitives";

import type { PostwsGenerativeAiAppGroupIdStandardsRulesetSynthesisResult, SynthesizedRuleset } from "./types";

const isSynthesizedRuleset = objectOf<SynthesizedRuleset>({
  name: string,
  rules: arrayOf(string),
  scope: maybe(string, true),
});

export const isPostwsGenerativeAiAppGroupIdStandardsRulesetSynthesisResult =
  objectOf<PostwsGenerativeAiAppGroupIdStandardsRulesetSynthesisResult>({
    status: number,
    rulesets: maybe(arrayOf(isSynthesizedRuleset), true),
    truncated: maybe(boolean, true),
    error_code: maybe(string, true),
  });
